// Import react
import React, { useState, useEffect } from "react";
import Header from "../components/header/boardHeader";
import Cards from "../components/board/cards";
import BoardDialogue from "../components/dialogue/boardDialogue";
import Copy from "../components/shareComponent/Copy";
import Mailer from "../components/shareComponent/Mailer";
import axios from "axios";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Avatar from "@mui/material/Avatar";

// Import react
import {
  getAllBoards,
  createBoard,
  updateBoard,
  deleteBoard,
  fetchSharedBoardEmails,
} from "../redux/actions/boardActions";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import LinkRoundedIcon from "@mui/icons-material/LinkRounded";
import { nanoid } from "nanoid";

import { useNavigate } from "react-router-dom";
import { Buffer } from "buffer";
import { useSelector, useDispatch } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import { Oval } from "react-loader-spinner";

// Import supabase configuration
import supabase from "../config/supabase";

// Import custom components
function Board() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const user = "Supply Team";
    const data = useSelector((state) => state.boards);
    const [boards, setBoards] = useState([]);
    const [board, setBoard] = useState({});
    const [createBoardFlag, setCreateBoardFlag] = useState(false);
    const [showLoader, setShowLoader] = useState(true);
    const [showMessage, setShowMessage] = useState(false);
    const [showShareModal, setshowShareModal] = useState(false);
    const [emailDiv, setemailDiv] = useState(false);
    const [copyDiv, setcopyDiv] = useState(true);
    const [userEmail, setUserEmail] = useState("");
    const [emailFromClient, setEmailFromClient] = useState([]);
    const [expire, setExpire] = useState(10);
    const [checked, setChecked] = React.useState(false);
    const [successfullMessage, setSuccessfullMessage] = useState("");
    const [boardId, setBoardId] = useState("");
    const [clientUrl, setClientUrl] = useState("");
    const [boardObject, setBoardObject] = useState({});
    const [url, setUrl] = useState("");
    const [urlPlaceholder, setUrlPlaceholder] = useState("");
    const [open, setOpen] = React.useState(false);
    const [openNew, setOpenNew] = React.useState(false);
    const [defaultExpiry, setDefaultExpiry] = useState();
    const [filter, setFilter] = useState("Newest");

    const selectorEmails = useSelector((state) => state.boardsEmail);
  // const [emails, setEmails] = useState([]);
  var emails = [];
  
    useEffect(async() => {
      document.title = "Add Board";
      window.scrollTo(0, 0);
  
     await dispatch(getAllBoards()).then(() => {
      }).catch(() => {
        setSuccessfullMessage("Something went wrong.");
      })
    }, []);

    useEffect(()=>{
      if(selectorEmails.length > 0){
        for (var i = 0; i < selectorEmails.length; i++) {
          emails.push({ email: selectorEmails[i].email, expireDate: selectorEmails[i].expireDate, linkSharedAt: selectorEmails[i].link_shared_at, link: selectorEmails[i].url_with_token, masked_url: selectorEmails[i].masked_url });
        }
        remainingDaysForLink(emails);
      }
      else{
        setEmailFromClient([]);
      }
    },[selectorEmails])

    useEffect(() => {
      data.length > 0 && all_profiles(data);
    }, [data]);
  
    const all_profiles = async(boards) => {
      let allIds = [];
      var all_profiles = [];
      var board_all_Profiles = [];
  
      boards.forEach( (board) => {
        let p =board?.board_profiles ? board.board_profiles[0]?.profiles : []
        all_profiles.push(p);
      })
  
      all_profiles.forEach( (profiles) => {
        for(var i =0 ; i< profiles?.length ; i++){
          if(!allIds.includes(profiles[i].id) && allIds.length > 0){
            allIds.push(profiles[i].id);
          }
          else if(allIds.length == 0){
            allIds.push(profiles[i].id);
          }
        }
      })

      // Boards are empty
      if(allIds.length <= 0){
        boards.forEach( (board) => {
          board_all_Profiles.push({
            "id" : board.id,
            "board_url" : board?.board_profiles.length > 0 ? board?.board_profiles[0]?.url : "",
            "masked_url" : board?.board_profiles.length > 0 ? board?.board_profiles[0]?.masked_url : "",
            "expireDate" : board?.board_profiles[0]?.expireDate,
            "activeLink": board?.board_profiles[0]?.activeLink,
            "title" : board.name,
            "created_at": board.created_at,
            "boardProfilesWithoutDetails" : board?.board_profiles[0]?.profiles,
            "candidates" : []
          })
        })
      }
      // else
      else{
        var { data, error } = await supabase
        .from("all_profiles")
        .select("*")
        .in('id', allIds);
  
        if(data && data.length > 0){
          all_profiles.forEach( (profiles,ind) => {
            var candidates = [];
            for(var i =0 ; i< profiles?.length ; i++){
              let profile = data.filter(p => p.id === profiles[i].id)[0];
              if(profile){
                profile.bg_color = profile.bg_color ? profile.bg_color : getRandomColor();
                candidates.push(profile);
              }
             
            }
  
            board_all_Profiles.push({
              "id" : boards[ind].id,
              "board_url" : boards[ind]?.board_profiles[0]?.url ,
              "masked_url" : boards[ind]?.board_profiles[0]?.masked_url ,
              "expireDate" : boards[ind]?.board_profiles[0]?.expireDate,
              "title" : boards[ind].name,
              "created_at": boards[ind].created_at,
              "activeLink": boards[ind]?.board_profiles[0]?.activeLink,
              "boardProfilesWithoutDetails" : boards[ind]?.board_profiles[0]?.profiles || [],
              "candidates" : candidates
            })
          })
        }
      }

      // Apply filters
      board_all_Profiles.sort(function(a, b) {
        var c = new Date(a.created_at);
        var d = new Date(b.created_at);
        return d-c;
      });

      setBoards(board_all_Profiles);
      setShowLoader(false);
      setShowMessage(true);
      board_all_Profiles.length > 0 ? setSuccessfullMessage("Boards have been loaded successfully.") :  setSuccessfullMessage("Please add new baord.");

    }
  
    const closeModal = () => {
      setCreateBoardFlag(!createBoardFlag);
    };

    const insertUrl = async (url, boardId, check) => {
      if (check == "insert") {
        let masked_url = window.location.origin + "/redirect?" + nanoid().substring(0, 6);

        const { data, error } = await supabase
          .from("board_profiles")
          .insert([{ url: url, board: boardId ,masked_url: masked_url}]);
      } else {
        const { data, error } = await supabase
          .from("board_profiles")
          .update([{ url }])
          .match({ board: boardId });
      }
    };

    const createNewBoard = (value) => {
      setShowLoader(true);
      closeModal();
      dispatch(createBoard({ name: value })); 
      dispatch(getAllBoards())
      setTimeout(() => {
        setShowLoader(false);
      }, 700);
    };
  
    const viewBoard = (boardId) => {
      navigate(`/boardDetails?id=${Buffer.from(boardId, "utf8").toString("base64")}`);
    };
  
    const setBoardName = (boardName) => {
      localStorage.setItem("board", boardName);
    };

    const toEditBoard = (id,name) => {
      var recentBoards = JSON.parse(localStorage.getItem('recentBoards')) || [];
      var isExist = false
      recentBoards = recentBoards.map((a) => {
        if(a.id == id) {
          isExist = true;
          a.count += 1;
          return a;
        } else {
          return a;
        }
      })
      if(!isExist){
        recentBoards = [...recentBoards, {id: id, count: 1}]
      }
      localStorage.setItem('recentBoards', JSON.stringify(recentBoards));
      setBoardName(name);
      viewBoard(id);
    }

    const createUrl = () => {
      var Id = nanoid();
      var board_id = Buffer.from(boardId, "utf-8").toString("base64");
  
      var newId = board_id.concat("/", Id);
      var str = `${window.location.origin}/client?id=`;
      var newUrl = str.concat(newId);
  
      return newUrl;
    };

    const insertClientInvitation = async (userEmail, c_url) => {
      var { data, error } = await supabase
        .from("board_clients_invitation")
        .select("*")
        .match({ email: userEmail, board: boardId });
  
      if (data && data.length) {
        // Set states
        setShowMessage(true);
        setSuccessfullMessage("Board is already shared with this client.");
      } 
      else {
        var profiles = boardObject.profiles;
        for (var i = 0; i < profiles.length; i++) {
          profiles[i].status = "New";
          profiles[i].message = "";
          profiles[i].meetingTime = "";
          profiles[i].endMeetingTime = "";
        }

        var dashboard_id = "";
        // Check if already any board is shared with this email

        var { data, error } = await supabase
        .from("board_clients_invitation")
        .select("*")
        .match({ email: userEmail});
  
        if(data && data.length){
          dashboard_id = data[0].dashboard_id;
        }

        let masked_url = window.location.origin + "/redirect?" + nanoid().substring(0, 6);

        var { data, error } = await supabase
          .from("board_clients_invitation")
          .insert([
            {
              email: userEmail,
              expireDate: 10,
              profiles: profiles,
              board: boardObject.id,
              url_with_token: c_url,
              dashboard_id: dashboard_id ? dashboard_id : nanoid(),
              masked_url:masked_url,
            },
          ]);

          if(data && data.length > 0){
            setShowMessage(true);
            setSuccessfullMessage("Board is shared successfully.");
          }
          else{
            setShowMessage(true);
            setSuccessfullMessage("please try again.");
          }
  
      }
    };

    const handleClose = () => {
      setOpen(false);
      setOpenNew(false);
      setshowShareModal(false);
    };

    const checkEmailExist = async (boardId) => {
      dispatch(fetchSharedBoardEmails(boardId));
    };

    const updateDefaultExpire = async (defaultExpire) => {
      const { data, error } = await supabase
        .from("board_profiles")
        .update([{ expireDate: defaultExpire }])
        .match({ board: boardId });
  
      if (data && data.length) {
        setDefaultExpiry(defaultExpire);
        setShowMessage(true);
        setSuccessfullMessage("Expire updated successfully.");
      }
    };

    const handleOpen = async(boardId) => {
      setEmailFromClient([]);

      checkEmailExist(boardId);

      let selectedboard = boards.filter(b => b.id == boardId)[0];

      setDefaultExpiry(selectedboard?.expireDate);
      setChecked(selectedboard?.activeLink);

      setBoardObject({
        "profiles" :selectedboard?.boardProfilesWithoutDetails,
        "id":selectedboard?.id })
    
        if (selectedboard.board_url || selectedboard.masked_url) {
          setUrl(selectedboard.masked_url ? selectedboard.masked_url : selectedboard.board_url);
        } else {
        var board_id = Buffer.from(boardId, "utf-8").toString("base64");
        var url = `${window.location.origin}/client?id=${board_id}`;
        setUrl(url);
        insertUrl(url, boardId, selectedboard? "update" : "insert");
      }

      setBoardId(boardId)
      // setOpen(true);
      setshowShareModal(true);
    };

    const remainingDaysForLink = (emails) => {
      if(emails?.length > 0){
        var newMails = [];
        emails.forEach( (mail) => {
          const expire = mail.expireDate;
          const link_shared_at = new Date(mail.linkSharedAt);

          // Today's date
          const currentDate = new Date();

          var expireDate = new Date();
          expireDate.setDate(link_shared_at.getDate() + expire);
  
          // To calculate the time difference of two dates
          let Difference_In_Time = expireDate.getTime() - currentDate.getTime();

          // To calculate the no. of days between two dates
          let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
          Difference_In_Days = Difference_In_Days > 0 ? Difference_In_Days : 0;
          mail = { ... mail, remainingDays: Difference_In_Days};
          newMails.push(mail);
        })
        setEmailFromClient(newMails);
      }
    }

    const deleteClient = async (email) => {
      var { data, error } = await supabase
    .from("board_clients_invitation")
    .select("*")
    .match({ board: boardId });

    if(data && data.length){
      let invitations = data;
      for(var i=0 ; i < invitations.length ; i++){
        const { data, error } = await supabase
        .from("notifications")
        .delete()
        .match({ client: invitations[i].id });
      }
    }
      var { data, error } = await supabase
        .from("board_clients_invitation")
        .delete()
        .match({ email: email, board: boardId });
  
      if (data && data.length) {
        setShowMessage(true);
        setSuccessfullMessage("Client has been removed successfully.");
        checkEmailExist(boardId);
      } else {
        setShowMessage(true);
        setSuccessfullMessage("Please try again.");
      }
    };

    const updateClientExpire = async (newExpire, clientEmail) => {
      const { data, error } = await supabase
        .from("board_clients_invitation")
        .update([{ expireDate: newExpire }])
        .match({ email: clientEmail, board: boardId });
  
      if (data && data.length) {
        setShowMessage(true);
        checkEmailExist(boardId);
        setSuccessfullMessage("Expire updated successfully.");
      }
    };
  
    async function sendEmailNotification(message) {
      //Setting email template params
      var templateParams = {
        message: message,
        email: "no-reply@gaper.io",
        subject: "New Board Invitation",
        to: userEmail,
      };
  
      //Sending email
      axios
        .post(
          // "http://localhost:5000/sendEmail",
          "https://gaper-email-service.herokuapp.com/sendEmail",
          templateParams,
          {
            headers: { key: "1eb2cy567keyoipaex-assqwe12" },
          }
        )
        .then(function (response) {
          console.log("email sent")
        })
        .catch(function (error) {
          console.log("email not sent")
        });
    }

    const sendInvitation = async() => {
      var c_url = createUrl();
      setClientUrl(c_url);
      await insertClientInvitation(userEmail, c_url);
      await checkEmailExist(boardId)
      let clientName = userEmail.split('@')[0];
      setUserEmail("");
  
      const { data, error } = await supabase
        .from("board_profiles")
        .select("profiles_screenshot")
        .match({ board: boardId });

        if(data && data.length > 0){
          sendEmailNotification(`<div>
          <div style="padding-top:25px">
              <img src="https://yourimageshare.com/ib/ImZrKL2FsS.png" alt="GaperLogo here" height="10%" width="20%" />
          </div>
          <div style="padding:15px 50px">
          <p style=" font-size: 17px;  font-family: 'Poppins', sans-serif; margin: 0px;">Hi ${clientName},</p>
          <p style=" font-size: 16px; font-family: 'Poppins', sans-serif; margin: 0px; padding-top: 3px;">We have customised a team of engineer specific for you.</p>
          <div style="margin-top:20px; font-family: 'Poppins', sans-serif; text-align: center;  position:relative;">
              <div style="padding:40px 0px; border:0.9px solid #C8C8C8; border-radius:10px;">
              <a href='${c_url}'>
              <img src="${data[0].profiles_screenshot}" height="40%" width="90%" alt="ScreenShot Image here" /> </a>
              </div>
              <br />
              <div style="text-align: center;">
              <a href='${c_url}'>
                <button style="background-color: #0C60FF; color:#fff; height:42px; width:170px; border-radius: 4px; border: none; font-size: 18px; font-family: 'Inter', sans-serif; text-align: center;">View list</button>
              </a>
              </div>
              <p style="font-family: 'Poppins', sans-serif; font-size: 16px; color:black;">This list is valid for 10 days, Hope to see you soon.</p>
          </div>
          </div>
          </div>`);
        }
    };

    function getRandomColor() {
      var letters = 'BCDEF'.split('');
      var color = '#';
      for (var i = 0; i < 6; i++ ) {
          color += letters[Math.floor(Math.random() * letters.length)];
      }
      return color;
    }

    const action = (
      <React.Fragment>
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={() => setShowMessage(false)}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </React.Fragment>
    );

    function applyFilter(filter){

      var all_boards = [...boards];

      // Apply filters
      if(filter == "Newest"){
        all_boards.sort(function(a, b) {
          var c = new Date(a.created_at);
          var d = new Date(b.created_at);
          return d-c;
        });
      }
      if(filter == "Recent"){
        var recentBoards = JSON.parse(localStorage.getItem('recentBoards')) || [];
        var sortedBoard = [];
        var max = 0;
        all_boards.forEach(function(a) {
          var count = getOccurrence(recentBoards, a.id);
          if(max < count) {
            max = count;
            sortedBoard = [a, ...sortedBoard];
          }
          else {
            sortedBoard.push(a);
          }
        });
        all_boards = sortedBoard;
      }
      if(filter == "Ascending"){
        all_boards.sort( (a,b) => {
          let fa = a.title.toLowerCase(),
          fb = b.title.toLowerCase();
  
          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
              return 1;
          }
          return 0;
  
        })
      }
      if(filter == "Descending"){
        all_boards.sort( (a,b) => {
          let fa = a.title.toLowerCase(),
          fb = b.title.toLowerCase();
  
          if (fa < fb) {
            return 1;
          }
          if (fa > fb) {
              return -1;
          }
          return 0;
  
        })
      }
      
      setBoards(all_boards);

      setFilter(filter);
      console.log(all_boards)
    }

    function getOccurrence(array, value) {
      var count = 0;
      array.forEach((v) => {
        if(v.id === value){
          count = v.count
        }
      });
      return count;
    }

    return (
        <div className="bg-[#E9F7FF] h-fit pb-10">
          <div className="sticky top-0 z-50">
            <Header current="home" />
          </div>
          {/* Notification */}
        
          {
            <Snackbar
              open={showMessage}
              onClose={() => setShowMessage(false)}
              autoHideDuration={2000}
              message={successfullMessage}
              action={action}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            />
          }
          <BoardDialogue
          open={createBoardFlag}
          handleModal={createNewBoard}
          board={board}
          closeModal={closeModal}
          />

          {showShareModal ? (
          <>
            <div className={`justify-center w-auto items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none `}>
              <div className={`absolute opacity-20 bg-black-1 w-full h-full`}></div>

              <div className="relative w-auto my-6 mx-auto max-w-3xl w-5/6 sm:w-3/5 md:w-1/2 lg:w-2/5" >
                {/*content*/}
                <div className="border-0 rounded-lg relative flex flex-col w-full bg-white-1 outline-none focus:outline-none scrollbar">
                  {/*header*/}
                  <div
                    onClick={() => {
                      setemailDiv(false);
                      setcopyDiv(true);
                    }}
                    className="flex items-start justify-between p-8 rounded-t -mt-4"
                  >
                    <div className="-ml-3 -mb-8 flex items-center">
                      <div className={`bg-blue-1 rounded-full p-1 mx-1 inline-block ${emailDiv? "hidden":""}`}>
                        {/* <<PersonAddAltRoundedIcon className="text-white-1" />> */}
                        <img src="/addPerson.svg" style={{width: 24, height: 24}} />
                      </div>
                      <h3 className="text-lg font-semibold my-1 inline-block ">
                        Share board with people
                      </h3>
                    </div>
                    <button
                      className="p-1 -px-6 ml-auto bg-transparent border-0 text-blue-1  float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                      onClick={() => setshowShareModal(false)}
                    >
                      <span className="bg-transparent text-black opacity-100 h-6 w-6 text-2xl block outline-none focus:outline-none">
                        ×
                      </span>
                    </button>
                  </div>

                  {emailDiv ? (
                    <div className="select-none px-8 -mt-2">
                      {emailFromClient.length ? (
                        <div>
                          <div className="flex items-center -ml-3">
                          <div className={`bg-blue-1 rounded-full p-1 mx-1 inline-block`}>
                            {/* <<PersonAddAltRoundedIcon className="text-white-1" />> */}
                             <img src="/addPerson.svg" style={{width: 24, height: 24}} />
                          </div>
                          <div className="font-semibold">Shared with: </div>
                          </div>
                          <div className="scrollbar" style={{overflowY: "auto", maxHeight: "200px"}}>
                          {emailFromClient.map((client, index) => {
                            return (
                              <div key={index} className={`w-fit inline-block text-sm rounded-full m-2 p-2`} style={{backgroundColor: getRandomColor()}}>
                                <span className="opacity-100">{client.email}</span>
                              </div>
                            );
                          })}
                          </div>
                        </div>
                      ) : (
                        <div>No one has been added yet</div>
                      )}
                    </div>
                  ) : null}

                  {/*body*/}
                  <div
                    className={`relative py-4 px-3 flex-auto ${
                      emailDiv ? "hidden" : ""
                    }`}
                  >
                    <div className="-mt-8 ml-1">
                      <Mailer
                        userEmail={userEmail}
                        getChange={(data) => {
                          setUserEmail(data);
                        }}
                        emailFromClient={emailFromClient}
                        setshowShareModal={setshowShareModal}
                        sendInvitation={sendInvitation}
                        deleteClient={deleteClient}
                        updateClientExpire={updateClientExpire}
                      />
                    </div>
                  </div>

                  {/*Copy*/}
                  <div className="-mt-6">
                    <div
                      onClick={() => {
                        setemailDiv(true);
                        setcopyDiv(false);
                      }}
                      className="flex items-start justify-between p-8 rounded-t"
                    >
                      <div className="-ml-3 ">
                        <div className="bg-blue-1 rounded-full p-1 mx-1 inline-block">
                          <LinkRoundedIcon className="text-white-1" />
                        </div>
                        <h3 className="text-lg font-semibold my-1 inline-block ">
                          Copy Link
                        </h3>
                      </div>
                      <button
                        disabled
                        className="p-1 ml-auto bg-transparent border-0 text-blue-1  float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                        onClick={() => setshowShareModal(false)}
                      >
                        <span className="bg-transparent text-black opacity-0 h-6 w-6 text-2xl block outline-none focus:outline-none">
                          ×
                        </span>
                      </button>
                    </div>
                    {copyDiv ? (
                      <div className="select-none text-sm px-8 mb-4 -mt-4 ...">
                        Anyone on the internet with this link can view
                      </div>
                    ) : null}
                    {/*Copy body*/}
                    <div
                      className={`relative flex-auto ${copyDiv ? "hidden" : ""}`}
                    >
                      <div className="-mt-6">
                        <Copy
                          url={url}
                          urlPlaceholder={urlPlaceholder}
                          checked={checked}
                          handleClose={handleClose}
                          updateDefaultExpire={updateDefaultExpire}
                          defaultExpiry={defaultExpiry}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null}

          {/* Page heading  */}
          <div className="flex flex-col items-center justify-center mt-12 mb-7 space-y-12">
              <div className="flex flex-col items-center justify-center space-y-6">
                <div className="space-y-3 flex flex-col items-center justify-center">
                  <h1 className="text-4xl md:text-5xl font-bold leading-12">{user}</h1>
                  <h2 className="text-2xl font-medium leading-6 ">Manage boards</h2>
                </div>
                  
                <button className="bg-[#C7DAFF] px-3 py-2 rounded-md text-[#204ECF] font-medium text-base focus:outline-none cursor-pointer" onClick={() => setCreateBoardFlag(true)}>Create a new board</button>
              </div>
             
              {/* Filters */}
              <div className="flex items-center py-2.5 px-3 bg-white-1 md:space-x-14 omd-1:justify-between omd-1:w-[94%] rounded-md md:text-base text-sm">
                <div className={`${filter == "Newest" && "bg-[#C7DAFF] text-blue-1 p-2.5 rounded-md "} cursor-pointer`} onClick={() => applyFilter("Newest")}>Newest</div>
                <div className={`${filter == "Recent" && "bg-[#C7DAFF] text-blue-1 p-2.5 rounded-md"} cursor-pointer`} onClick={() => applyFilter("Recent")}>Recent</div>
                <div className={`${filter == "Ascending" && "bg-[#C7DAFF] text-blue-1 p-2.5 rounded-md"} cursor-pointer`} onClick={() => applyFilter("Ascending")}>Ascending</div>
                <div className={`${filter == "Descending" && "bg-[#C7DAFF] text-blue-1 p-2.5 rounded-md"} cursor-pointer`} onClick={() => applyFilter("Descending")}>Descending</div>
              </div>
          </div>

          {/* Cards */}
          <div className="flex flex-wrap justify-center mx-auto gap-x-6 gap-y-9 max-w-7xl ">
              <Cards boards={boards} handleOpen={handleOpen} toEditBoard = {toEditBoard} showLoader={showLoader}/>
          </div>
      </div>
    )
}

export default Board;